import { z } from 'zod';

// Schema Zod del search param de /f29. Single source of truth del shape
// de la URL. Pattern espejo de invoicing/constants/search-params.ts.
//
// URL canónica:
//   /f29?period=2026-05&tipoEmpresa=spa
//   /f29?period=2026-05&gestion=monto_enviado&q=acme&selected=<uuid>

/**
 * `tipoEmpresa` mapea el filter contra clients.tipo_empresa. NO es la
 * entidad facturadora de Simplificalo (eso aplica solo a Facturación);
 * acá filtra por la forma legal del cliente declarante.
 *
 * 'consolidado' = sin filtro (todos los tipos).
 */
export const F29_TIPO_EMPRESA_OPTIONS = [
  'consolidado',
  'spa',
  'ltda',
  'eirl',
  'sa',
  'natural',
  'otra',
] as const;
export type F29TipoEmpresaParam = (typeof F29_TIPO_EMPRESA_OPTIONS)[number];

export const F29_GESTION_OPTIONS = [
  'preparando',
  'monto_enviado',
  'pago_recibido',
  'declarado_sii',
  'comprobante_enviado',
  'cerrado',
] as const;

export const F29_SOLO_OPTIONS = ['listos', 'anomalias', 'falta_iusc', 'pendiente_n2', 'cerradas', 'con_bloqueos', 'con_advertencias', 'con_discrepancias', 'limpios'] as const;

export const f29SearchSchema = z.object({
  /** Período YYYY-MM (default = mes en curso, computado en useF29Search). */
  period: z
    .string()
    .regex(/^\d{4}-\d{2}$/, 'Período debe ser YYYY-MM')
    .optional(),
  /** Filtro tipo legal del cliente. 'consolidado' (o ausente) = todos. */
  tipoEmpresa: z.enum(F29_TIPO_EMPRESA_OPTIONS).default('consolidado'),
  /** Filtro por estado del pipeline de gestión. */
  gestion: z.enum(F29_GESTION_OPTIONS).optional(),
  /** Toggle: solo declaraciones con IVA postergado > 0. */
  ivaPostergado: z.literal('1').optional(),
  /** Filtros rápidos. */
  solo: z.enum(F29_SOLO_OPTIONS).optional(),
  /** Filtro por ejecutivo asignado al cliente. */
  ejecutivo: z.string().uuid().optional(),
  /** Búsqueda libre por nombre o RUT del cliente. */
  q: z.string().optional(),
  /** ID de la declaración con fila expandida en la grilla. */
  selected: z.string().uuid().optional(),
});

export type F29Search = z.infer<typeof f29SearchSchema>;

export const F29_TIPO_EMPRESA_LABELS: Record<F29TipoEmpresaParam, string> = {
  consolidado: 'Consolidado',
  spa: 'SpA',
  ltda: 'Ltda',
  eirl: 'EIRL',
  sa: 'SA',
  natural: 'Persona natural',
  otra: 'Otras',
};
